import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Card, message, Select, Spin, AutoComplete, Input, Button } from 'antd';
import axios from 'axios';
import { Option } from 'antd/es/mentions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { api } from '../../../../config/api';

const IdentificarConsumidor = ({
  isVisible,
  onClose,
  nomeDoCupom,
  documentoDoCupom,
  setConsumidorIdentificado,
  consumidorIdentificado,
  consumidor,
  setConsumidor,
  documentoIntegracao,
  setEmailNota,
  emailNota,
  telefoneEnvio,
  setTelefoneEnvio,
  telaOrcamento
}) => {
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [cep, setCep] = useState('');
  const [bairro, setBairro] = useState('');
  const [documentoRgIE, setDocumentoRgIE] = useState('');
  const [cidades, setCidades] = useState([]);
  const [estados, setEstados] = useState([]);
  const [paises, setPaises] = useState([]);
  const [estadoSelecionado, setEstadoSelecionado] = useState(
    consumidor?.endereco?.cidade?.cuf,
  );
  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [cpfCnpjMask, setCpfCnpjMask] = useState('cpf');
  const [codigoPais, setCodigoPais] = useState('55');

  const [restauranteId, setRestauranteId] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const operador = window.localStorage.getItem('operador');

  const [consumidorJaCadastrado, setConsumirJaCadastrado] = useState(false);

  const [cidadeIBGE, setCidadeIBGE] = useState(null);

  // --- estados e refs para o AutoComplete de Nome ---
  const [optionsAC, setOptionsAC] = useState([]);
  const [loadingSugestoes, setLoadingSugestoes] = useState(false);
  const debounceRef = useRef(null);
  const cancelSourceRef = useRef(null);

  // options (headers) para as chamadas com token
  const authOptions = useMemo(() => ({
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  }), [accessToken]);

  useEffect(() => {
    if (accessToken && idUser) {
      axios
        .get(
          `${api.techspdv}/v1/paises`,
          authOptions,
        )
        .then(paises => {
          const comboPaises = paises.data._embedded.paises.map(pais => ({
            label: `${pais.codigo} - ${pais.nome}`,
            value: `${pais.codigo}`,
          }));

          setPaises(comboPaises);
        });
    }
  }, [idUser, accessToken, authOptions]);

  useEffect(() => {
    if (accessToken && idUser) {
      axios
        .get(
          `${api.techfood}/v1/restaurantes/usuario/${idUser}`,
          authOptions,
        )
        .then(restaurante => {
          setRestauranteId(restaurante.data.id);
          if (documentoIntegracao) {
            setCpfCnpj(documentoIntegracao);
          }
        });

      axios
        .get(
          `${api.techspdv}/v1/estados`,
          authOptions,
        )
        .then(estados => {
          const comboEstados = estados.data._embedded.estados.map(estado => ({
            label: `${estado.nome} - ${estado.uf}`,
            value: estado.cuf,
          }));

          setEstados(comboEstados);
        });
    }
  }, [idUser, accessToken, authOptions]);

  useEffect(() => {
    if (accessToken && idUser && estadoSelecionado) {
      setCidades([]);
      setCidadeSelecionada(null);

      axios
        .get(
          `${api.techspdv}/v1/cidades/listarPorEstadoCuf/${estadoSelecionado}`,
          authOptions,
        )
        .then(response => {
          const comboCidades = response.data._embedded.cidades.map(cidade => ({
            label: cidade.nome,
            value: cidade.ibge,
            id: cidade.id,
          }));

          setCidades(comboCidades);

          if (cidadeIBGE) {
            const cidadeCorrespondente = comboCidades.find(c => c.value === cidadeIBGE);
            if (cidadeCorrespondente) {
              setCidadeSelecionada(cidadeCorrespondente.value);
            } else {
              console.warn('Cidade não encontrada na lista carregada:', cidadeIBGE);
            }
            setCidadeIBGE(null);
          }

          setIsLoading(false);
        });
    }
  }, [idUser, accessToken, estadoSelecionado, cidadeIBGE, authOptions]);

  useEffect(() => {
    if (consumidor == true) {
    } else {
      if (consumidor) {
        setCpfCnpj(consumidor?.documentoCpfCnpj);
        setNome(consumidor?.nomeCompleto);
        setEmail(consumidor?.email);

        let telefoneLimpo = consumidor.telefone ? consumidor.telefone.replace(/\D/g, '') : '';
        telefoneLimpo = telefoneLimpo.replace(/^55/, '');

        handleTelefoneChange(telefoneLimpo);
        if (consumidor.endereco) {
          setLogradouro(consumidor?.endereco?.logradouro);
          setNumero(consumidor?.endereco?.numero);
          setComplemento(consumidor?.endereco?.complemento);
          setBairro(consumidor?.endereco?.bairro);
          setDocumentoRgIE(consumidor?.documentoRgIE);
          setCep(consumidor?.endereco?.cep);
          setCidadeSelecionada(consumidor?.endereco?.cidade?.ibge);
          setEstadoSelecionado(consumidor?.endereco?.cidade?.cuf);
        }
      }
    }
  }, [consumidor]);

  const confirmarConsumidor = async () => {
    setConsumidorIdentificado(true);

    const nomeCidade = cidades.find(
      cidade => cidade.value === cidadeSelecionada,
    );

    const estadoNome = estados.find(
      estado => estado.value === estadoSelecionado,
    );

    const uf = estadoNome?.label.split(" - ")[1] || "";

    let consumidorAux = {
      nomeCompleto: nome,
      documentoCpfCnpj: cpfCnpj,
      documentoRgIE: documentoRgIE,
      email: email,
      ie: documentoRgIE,
      telefone: telefone,
      endereco: {
        cep: cep ? cep : "",
        logradouro: logradouro,
        numero: numero,
        complemento: complemento,
        bairro: bairro,
        ufEstado: uf || null,
        cidade: {
          ibge: cidadeSelecionada,
          cuf: estadoSelecionado,
          nome: nomeCidade?.label || null
        },
      },
    };

    if (consumidorJaCadastrado && consumidor.id) {
      consumidorAux.id = consumidor.id;
      consumidorAux.dataCadastro = consumidor.dataCadastro;
    }

    documentoDoCupom(cpfCnpj);
    nomeDoCupom(consumidorAux.nomeCompleto);
    setConsumidor(consumidorAux);
    onClose();
    return;
  };

  const salvarConsumidor = () => {
    setIsLoading(true);
    const cidadeSelecionadaAux = cidades.find(
      cidade => cidade.value === cidadeSelecionada,
    );

    const options = authOptions;

    let consumidorForm = {
      ativo: true,
      documentoCpfCnpj: cpfCnpj,
      documentoRgIE: documentoRgIE,
      email: email,
      endereco: {
        bairro: bairro,
        cep: cep,
        cidade: {
          id: cidadeSelecionadaAux.id || '',
        },
        complemento: complemento,
        logradouro: logradouro,
        numero: numero,
      },
      nomeCompleto: nome,
      telefone: limparStringNumerica(`${codigoPais}${telefone}`),
      dataCadastro: consumidor.dataCadastro,
    };

    /*if (consumidor?.id) {
      consumidorForm.id = consumidor?.id;
    }*/

    if (consumidor !== undefined && consumidor !== true) {
      axios
        .put(
          `${api.techspdv}/v1/clientes/loja/${restauranteId}/${consumidor.id}`,
          consumidorForm,
          options,
        )
        .then(response => {
          setConsumidor(response.data);
          documentoDoCupom(response.data.documentoCpfCnpj);
          nomeDoCupom(response.data.nomeCompleto);
          setConsumidorIdentificado(true);
          setIsLoading(false);
          onClose();
          return;
        })
        .catch(error => {
          setIsLoading(false);
          console.error('Erro:', error);
        });
    } else {
      axios
        .post(
          `${api.techspdv}/v1/clientes/loja/${restauranteId}`,
          consumidorForm,
          options,
        )
        .then(response => {
          confirmarConsumidor();
        })
        .catch(error => {
          setIsLoading(false);
          console.error('Erro:', error);
        });
    }
  };

  const limparDados = () => {
    setNome('');
    setEmail('');
    setConsumidor(null);
    nomeDoCupom('');
    documentoDoCupom('');
    setCpfCnpj('');
    setTelefone('');
    setDocumentoRgIE('');
    setCep('');
    setBairro('');
    setLogradouro('');
    setNumero('');
    setConsumidorIdentificado(false);
  };

  function validarDocumento(documento) {
    documento = documento.replace(/[^\d]+/g, '');
    if (documento.length === 11) {
      let cpf = documento;
      let add = 0;
      for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
      let rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      if (rev !== parseInt(cpf.charAt(9))) return false;

      add = 0;
      for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
      rev = 11 - (add % 11);
      if (rev === 10 || rev === 11) rev = 0;
      if (rev !== parseInt(cpf.charAt(10))) return false;

      return true;
    } else if (documento.length === 14) {
      let cnpj = documento;
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(0))) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(1))) return false;

      return true;
    } else {
      return false;
    }
  }

  const buscarConsumidor = () => {
    if (!cpfCnpj) return;
    if (validarDocumento(cpfCnpj)) {
      const numericText = cpfCnpj.replace(/\D/g, '');
      setIsCnpj(numericText.length > 11);

      if (consumidor) {
        onClose();
        return;
      } else {
        if (accessToken) {
          setIsLoading(true);
          const options = authOptions;

          axios
            .get(
              `${api.techspdv}/v1/clientes/loja/${restauranteId}/cpfcnpj/${cpfCnpj}`,
              options,
            )
            .then(consumidorResp => {
              if (consumidorResp) {
                if (consumidorResp.data) {
                  setConsumidor(consumidorResp.data);
                  setConsumirJaCadastrado(true);
                  setIsLoading(false);
                } else {
                  setIsLoading(false);
                  setConsumidor(true);
                }
              } else {
                setIsLoading(false);
                setConsumidor(true);
              }

            }).catch(error => {
              console.error('Erro ao buscar consumidor:', error);
              setConsumidor(true);
            })
        }
      }
      return;
    }
  };

  const isTelefoneValido = (numero) => {
    const numeroLimpo = numero.replace(/\D/g, '');
    return (
      (numeroLimpo.length === 10 && /^(\d{2})(\d{4})(\d{4})$/.test(numeroLimpo)) ||
      (numeroLimpo.length === 11 && /^(\d{2})(\d{5})(\d{4})$/.test(numeroLimpo))
    );
  };

  const adicionarEmail = () => {
    if (email) {
      setEmailNota(email);
      onClose();
      return;
    }
    if (telefone) {
      if (isTelefoneValido(telefone)) {
        setTelefoneEnvio(codigoPais + telefone.replace(/\D/g, ''));
        onClose();
        return;
      }
    }
  };

  useEffect(() => {
    console.log(cep);
    console.log(cep.length);
    if (cep.length === 8) {
      console.log('entrei no viace');
      buscarEnderecoPorCep();
    }
  }, [cep]);

  useEffect(() => {
    if (cidadeIBGE && cidades.length > 0) {
      const cidadeEncontrada = cidades.find((c) => c.value === cidadeIBGE);
      if (cidadeEncontrada) {
        setCidadeSelecionada(cidadeEncontrada.value);
      } else {
        console.warn("Cidade não encontrada:", cidadeIBGE);
      }
      setCidadeIBGE(null);
    }
  }, [cidades, cidadeIBGE]);

  const buscarEnderecoPorCep = async () => {
    if (consumidorJaCadastrado && consumidor?.endereco?.cidade?.ibge) {
      setTimeout(() => {
        setCidadeSelecionada(consumidor.endereco.cidade.ibge);
      }, 1000);
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      const { data } = response;

      setBairro(data.bairro);
      setLogradouro(data.logradouro);

      if (data.ibge?.length === 7) {
        setEstadoSelecionado(data.ibge.substring(0, 2));
        setTimeout(() => {
          setCidadeIBGE(data.ibge);
        }, 1000);
      }
    } catch (error) {
      console.error("Erro ao buscar endereço:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onChangeCpfCnpj = text => {
    setCpfCnpj(text);
    const numericText = text.replace(/\D/g, '');
    if (numericText.length === 11) {
      setCpfCnpjMask('cpf');
    } else if (numericText.length === 14) {
      setCpfCnpjMask('cnpj');
    }
  };

  const [isCnpj, setIsCnpj] = useState(false);

  const toggleMask = text => {
    const numericText = text.replace(/\D/g, '');
    setIsCnpj(numericText.length > 10);
    setCpfCnpj(numericText);
  };

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = text => {
    setEmail(text);
  };

  const handleEmailBlur = () => {
    if (email.trim() !== '' && !validateEmail(email)) {
      message('E-mail Inválido', 'Por favor, insira um e-mail válido.');
    }
  };

  const handleTelefoneChange = text => {
    const numeroTelefone = text.replace(/\D/g, '');
    let telefoneFormatado = '';
    if (numeroTelefone.length <= 10) {
      telefoneFormatado = numeroTelefone.replace(
        /^(\d{2})(\d{4})(\d{4})$/,
        '($1) $2-$3',
      );
    } else {
      telefoneFormatado = numeroTelefone.replace(
        /^(\d{2})(\d{5})(\d{4})$/,
        '($1) $2-$3',
      );
    }
    setTelefone(telefoneFormatado);
  };

  function limparStringNumerica(string) {
    return string.replace(/[^0-9\s]/g, '');
  }

  // --------- BUSCA (AutoComplete) ----------
  const fetchSugestoesNome = async (q) => {
    if (!restauranteId) return;
    // cancelar requisição anterior
    if (cancelSourceRef.current) cancelSourceRef.current.cancel('Cancelado por nova busca');
    cancelSourceRef.current = axios.CancelToken.source();

    setLoadingSugestoes(true);
    try {
      const url = `${api.techspdv}/v1/clientes/loja/${restauranteId}/sugestoes/nome/${encodeURIComponent(q)}`;
      const { data } = await axios.get(url, {
        ...authOptions,
        cancelToken: cancelSourceRef.current.token,
      });

      const opts = (Array.isArray(data) ? data : []).map(item => ({
        value: item.nomeCompleto || '',
        label: item.nomeCompleto || '',
        doc: item.documentoCpfCnpj || '',
      }));
      setOptionsAC(opts);
    } catch (e) {
      if (!axios.isCancel(e)) {
        setOptionsAC([]);
      }
    } finally {
      setLoadingSugestoes(false);
    }
  };

  const handleSearchNome = (q) => {
    setNome(q);
    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!q || q.trim().length < 3) {
      setOptionsAC([]);
      return;
    }
    debounceRef.current = setTimeout(() => fetchSugestoesNome(q), 1000);
  };

  const handleSelectNome = (value, option) => {
    setNome(value);
    if (option?.doc) {
      // preenche CPF/CNPJ com o documento selecionado
      toggleMask(option.doc);
      documentoDoCupom(option.doc);
    }
  };

  return (
    <div style={styles.pagina}>
      <div style={styles.container}>
        <header style={styles.header}>
          <div style={styles.headerInfo}>
            <div style={styles.headerIcone}>
              👤
            </div>

            <div>
              <h1 style={styles.titulo}>
                Identificar Consumidor
              </h1>

              <span style={styles.subtitulo}>
                Informe os dados do consumidor para localizar ou
                cadastrar o cliente.
              </span>
            </div>
          </div>
        </header>

        {isLoading ? (
          <div style={styles.loading}>
            <Spin
              spinning={
                isLoading ||
                (!cidadeSelecionada && cep)
              }
              size="large"
            />

            <span style={styles.textoLoading}>
              Carregando...
            </span>
          </div>
        ) : (
          <>
            <div style={styles.gridPrincipal}>
              {/* Identificação */}
              <div style={styles.card}>
                <h3 style={styles.tituloSecao}>
                  🪪 Identificação
                </h3>

                <span style={styles.descricaoSecao}>
                  Localize o consumidor pelo nome ou documento.
                </span>

                <div style={styles.gridCampos}>
                  {/* Nome */}
                  <div style={styles.campoLarguraTotal}>
                    <label style={styles.label}>
                      Nome
                    </label>

                    <div
                      style={
                        telaOrcamento
                          ? styles.nomeGrid
                          : styles.nomeGridSemBotao
                      }
                    >
                      <AutoComplete
                        value={nome}
                        onSearch={handleSearchNome}
                        onChange={(v) => setNome(v)}
                        onSelect={handleSelectNome}
                        options={optionsAC}
                        style={{
                          width: '100%',
                        }}
                      >
                        <Input
                          placeholder="Nome do consumidor"
                          style={{
                            ...styles.input,
                            margin: 0,
                          }}
                          loading={
                            loadingSugestoes ? 1 : 0
                          }
                        />
                      </AutoComplete>

                      {telaOrcamento ? (
                        <Button
                          type="default"
                          onClick={() => {
                            documentoDoCupom(cpfCnpj);
                            nomeDoCupom(nome);
                            onClose();
                            return;
                          }}
                          style={styles.botaoSeta}
                          title="Usar consumidor no orçamento"
                        >
                          <FontAwesomeIcon
                            icon={faArrowRight}
                          />
                        </Button>
                      ) : null}
                    </div>
                  </div>

                  {/* CPF/CNPJ */}
                  <div style={styles.campo}>
                    <label style={styles.label}>
                      CPF ou CNPJ
                    </label>

                    <input
                      type="text"
                      placeholder="CPF ou CNPJ"
                      value={cpfCnpj}
                      onChange={(e) =>
                        toggleMask(e.target.value)
                      }
                      disabled={consumidor}
                      style={styles.input}
                    />
                  </div>

                  {/* RG/IE */}
                  {consumidor && (
                    <div style={styles.campo}>
                      <label style={styles.label}>
                        RG ou IE
                      </label>

                      <input
                        type="text"
                        placeholder="RG ou Inscrição Estadual"
                        value={documentoRgIE}
                        onChange={(e) =>
                          setDocumentoRgIE(
                            e.target.value
                          )
                        }
                        style={styles.input}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Contato */}
              <div style={styles.card}>
                <h3 style={styles.tituloSecao}>
                  📞 Contato
                </h3>

                <span style={styles.descricaoSecao}>
                  Informe pelo menos um meio de contato válido.
                </span>

                <div style={styles.gridCampos}>
                  {/* E-mail */}
                  <div style={styles.campoLarguraTotal}>
                    <label style={styles.label}>
                      E-mail
                    </label>

                    <input
                      type="text"
                      placeholder="email@exemplo.com"
                      value={email}
                      onChange={(e) =>
                        handleEmailChange(
                          e.target.value
                        )
                      }
                      onBlur={handleEmailBlur}
                      autoComplete="email"
                      style={styles.input}
                    />
                  </div>

                  {/* Telefone */}
                  <div style={styles.campoLarguraTotal}>
                    <label style={styles.label}>
                      Telefone
                    </label>

                    <div style={styles.telefoneGrid}>
                      <Select
                        value={codigoPais || undefined}
                        placeholder="País"
                        onChange={(valor) => {
                          setCodigoPais(valor);
                        }}
                        style={styles.select}
                        dropdownStyle={{
                          borderRadius: '9px',
                        }}
                        size="middle"
                      >
                        {paises.map((pais) => (
                          <Option
                            key={pais.value}
                            value={pais.value}
                          >
                            {pais.label}
                          </Option>
                        ))}
                      </Select>

                      <input
                        type="tel"
                        placeholder="Telefone"
                        value={telefone}
                        onChange={(e) =>
                          handleTelefoneChange(
                            e.target.value
                          )
                        }
                        style={styles.input}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Endereço */}
              {consumidor && (
                <div style={styles.cardLarguraTotal}>
                  <h3 style={styles.tituloSecao}>
                    📍 Endereço
                  </h3>

                  <span style={styles.descricaoSecao}>
                    Complete os dados necessários para cadastrar o
                    consumidor.
                  </span>

                  <div style={styles.gridEndereco}>
                    {/* CEP */}
                    <div style={styles.campo}>
                      <label style={styles.label}>
                        CEP
                      </label>

                      <input
                        type="text"
                        placeholder="CEP"
                        value={cep}
                        onChange={(e) => {
                          const cepSomenteNumeros =
                            e.target.value
                              .replace(/\D/g, '')
                              .slice(0, 8);

                          setCep(cepSomenteNumeros);
                        }}
                        inputMode="numeric"
                        style={styles.input}
                      />
                    </div>
                    {/* Estado */}
                    <div style={styles.campo}>
                      <label style={styles.label}>
                        Estado
                      </label>

                      <Select
                        value={
                          estadoSelecionado ||
                          undefined
                        }
                        placeholder="Selecione o estado"
                        onChange={(valor) => {
                          setEstadoSelecionado(valor);
                          setCidadeSelecionada('');
                        }}
                        style={styles.select}
                        dropdownStyle={{
                          borderRadius: '9px',
                        }}
                        size="middle"
                      >
                        {estados.map((estado) => (
                          <Option
                            key={estado.value}
                            value={estado.value}
                          >
                            {estado.label}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    {/* Cidade */}
                    <div style={styles.campo}>
                      <label style={styles.label}>
                        Cidade
                      </label>

                      <Select
                        value={
                          cidadeSelecionada ||
                          undefined
                        }
                        placeholder={
                          estadoSelecionado
                            ? 'Selecione a cidade'
                            : 'Selecione o estado primeiro'
                        }
                        onChange={(valor) => {
                          setCidadeSelecionada(valor);
                        }}
                        disabled={!estadoSelecionado}
                        style={styles.select}
                        dropdownStyle={{
                          borderRadius: '9px',
                        }}
                        size="middle"
                      >
                        {cidades.map((cidade) => (
                          <Option
                            key={cidade.value}
                            value={cidade.value}
                          >
                            {cidade.label}
                          </Option>
                        ))}
                      </Select>
                    </div>



                    {/* Bairro */}
                    <div style={styles.campo}>
                      <label style={styles.label}>
                        Bairro
                      </label>

                      <input
                        type="text"
                        placeholder="Bairro"
                        value={bairro}
                        onChange={(e) =>
                          setBairro(e.target.value)
                        }
                        style={styles.input}
                      />
                    </div>

                    {/* Logradouro */}
                    <div style={styles.campoDuasColunas}>
                      <label style={styles.label}>
                        Logradouro
                      </label>

                      <input
                        type="text"
                        placeholder="Rua, avenida..."
                        value={logradouro}
                        onChange={(e) =>
                          setLogradouro(
                            e.target.value
                          )
                        }
                        style={styles.input}
                      />
                    </div>

                    {/* Número */}
                    <div style={styles.campo}>
                      <label style={styles.label}>
                        Número
                      </label>

                      <input
                        type="text"
                        placeholder="Número"
                        value={numero}
                        onChange={(e) =>
                          setNumero(e.target.value)
                        }
                        style={styles.input}
                      />
                    </div>

                    {/* Complemento */}
                    <div style={styles.campoDuasColunas}>
                      <label style={styles.label}>
                        Complemento
                      </label>

                      <input
                        type="text"
                        placeholder="Apartamento, bloco, referência..."
                        value={complemento}
                        onChange={(e) =>
                          setComplemento(
                            e.target.value
                          )
                        }
                        style={styles.input}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Ações */}
            <div style={styles.actions}>
              {consumidor ? (
                <>
                  <button
                    onClick={confirmarConsumidor}
                    style={{
                      ...styles.button,
                      cursor:
                        !cidadeSelecionada && cep
                          ? 'not-allowed'
                          : 'pointer',
                      opacity:
                        !cidadeSelecionada && cep
                          ? 0.6
                          : 1,
                    }}
                    disabled={
                      !cidadeSelecionada && cep
                    }
                  >
                    ✓ Confirmar CPF/CNPJ na venda
                  </button>

                  <button
                    onClick={limparDados}
                    style={{
                      ...styles.button,
                      ...styles.buttonRed,
                    }}
                  >
                    🧹 Limpar dados
                  </button>

                  <button
                    onClick={salvarConsumidor}
                    style={{
                      ...styles.button,
                      cursor:
                        !cidadeSelecionada ||
                          !cpfCnpj ||
                          !nome ||
                          !estadoSelecionado ||
                          !cep ||
                          !cidadeSelecionada ||
                          !bairro ||
                          !logradouro ||
                          !numero
                          ? 'not-allowed'
                          : 'pointer',

                      opacity:
                        !cidadeSelecionada ||
                          !cpfCnpj ||
                          !nome ||
                          !estadoSelecionado ||
                          !cep ||
                          !cidadeSelecionada ||
                          !bairro ||
                          !logradouro ||
                          !numero
                          ? 0.6
                          : 1,
                    }}
                    disabled={
                      !cidadeSelecionada ||
                      !cpfCnpj ||
                      !nome ||
                      !estadoSelecionado ||
                      !cep ||
                      !cidadeSelecionada ||
                      !bairro ||
                      !logradouro ||
                      !numero
                    }
                  >
                    👤 Cadastrar cliente
                  </button>

                  <button
                    onClick={() => {
                      onClose();

                      if (!consumidorIdentificado) {
                        setConsumidor(null);
                        nomeDoCupom('');
                        documentoDoCupom('');
                      }
                    }}
                    style={{
                      ...styles.button,
                      ...styles.estiloBotaoFechar,
                    }}
                  >
                    ← Voltar
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => {
                      onClose();

                      if (!consumidorIdentificado) {
                        setConsumidor(null);
                        nomeDoCupom('');
                        documentoDoCupom('');
                      }
                    }}
                    style={{
                      ...styles.button,
                      ...styles.estiloBotaoFechar,
                    }}
                  >
                    Cancelar
                  </button>

                  <button
                    onClick={() => {
                      console.log(cpfCnpj);

                      if (
                        !validarDocumento(cpfCnpj) &&
                        !email &&
                        !isTelefoneValido(telefone)
                      ) {
                        message.warning(
                          'Informe pelo menos um CPF/CNPJ, e-mail ou telefone válido para prosseguir.'
                        );

                        return;
                      }

                      cpfCnpj
                        ? buscarConsumidor()
                        : adicionarEmail();
                    }}
                    disabled={isLoading}
                    style={{
                      ...styles.button,
                      ...(isLoading
                        ? styles.buttonDisabled
                        : {}),
                    }}
                  >
                    ✓ Confirmar
                  </button>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  pagina: {
    width: '100%',
    minHeight: '100%',
    padding: '16px',
    background: '#f4f6f9',
    boxSizing: 'border-box',
  },

  container: {
    width: '100%',
    maxWidth: '1100px',
    margin: '0 auto',
    padding: '18px',

    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',

    boxShadow:
      '0 8px 24px rgba(15, 23, 42, 0.08)',

    boxSizing: 'border-box',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '14px',

    paddingBottom: '14px',
    marginBottom: '14px',

    borderBottom: '1px solid #e5e7eb',
  },

  headerInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minWidth: 0,
  },

  headerIcone: {
    width: '46px',
    height: '46px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    flexShrink: 0,

    background: '#eef2ff',
    borderRadius: '12px',

    fontSize: '23px',
  },

  titulo: {
    margin: 0,

    color: '#111827',

    fontSize: '21px',
    fontWeight: '800',
  },

  subtitulo: {
    display: 'block',
    marginTop: '3px',

    color: '#6b7280',

    fontSize: '13px',
  },

  loading: {
    minHeight: '260px',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    width: '100%',
  },

  textoLoading: {
    marginTop: '16px',
    color: '#6b7280',
    fontSize: '14px',
    fontWeight: '600',
  },

  gridPrincipal: {
    display: 'grid',
    gridTemplateColumns:
      'repeat(2, minmax(0, 1fr))',
    gap: '12px',
    alignItems: 'start',
  },

  card: {
    padding: '14px',

    background: '#f8fafc',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',

    boxSizing: 'border-box',
  },

  cardLarguraTotal: {
    gridColumn: '1 / -1',

    padding: '14px',

    background: '#f8fafc',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',

    boxSizing: 'border-box',
  },

  tituloSecao: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',

    margin: '0 0 12px',

    color: '#374151',

    fontSize: '14px',
    fontWeight: '800',
  },

  descricaoSecao: {
    display: 'block',
    marginTop: '-5px',
    marginBottom: '13px',

    color: '#6b7280',

    fontSize: '12px',
  },

  gridCampos: {
    display: 'grid',
    gridTemplateColumns:
      'repeat(2, minmax(0, 1fr))',
    gap: '12px',
  },

  gridEndereco: {
    display: 'grid',
    gridTemplateColumns:
      'repeat(3, minmax(0, 1fr))',
    gap: '12px',
  },

  campo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    minWidth: 0,
  },

  campoLarguraTotal: {
    gridColumn: '1 / -1',

    display: 'flex',
    flexDirection: 'column',
    gap: '6px',

    minWidth: 0,
  },

  campoDuasColunas: {
    gridColumn: 'span 2',

    display: 'flex',
    flexDirection: 'column',
    gap: '6px',

    minWidth: 0,
  },

  label: {
    display: 'block',
    margin: 0,

    color: '#374151',

    fontSize: '12px',
    fontWeight: '700',
  },

  input: {
    width: '100%',
    height: '42px',

    margin: 0,
    padding: '0 11px',

    background: '#ffffff',

    border: '1px solid #d1d5db',
    borderRadius: '9px',

    color: '#111827',

    fontSize: '14px',
    outline: 'none',

    boxSizing: 'border-box',
  },

  select: {
    width: '100%',
    height: '42px',
  },

  telefoneGrid: {
    display: 'grid',
    gridTemplateColumns:
      'minmax(170px, 220px) minmax(0, 1fr)',
    gap: '10px',
    alignItems: 'start',
  },

  nomeGrid: {
    display: 'grid',
    gridTemplateColumns:
      'minmax(0, 1fr) 46px',
    gap: '8px',
    alignItems: 'end',
  },

  nomeGridSemBotao: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    gap: '8px',
  },

  botaoSeta: {
    width: '46px',
    height: '42px',

    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',

    padding: 0,

    background:
      'linear-gradient(135deg, #27272a, #000000)',

    color: '#ffffff',

    border: '1px solid #000000',
    borderRadius: '9px',

    cursor: 'pointer',

    boxShadow:
      '0 4px 10px rgba(0, 0, 0, 0.18)',
  },

  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',

    gap: '10px',

    paddingTop: '15px',
    marginTop: '15px',

    borderTop: '1px solid #e5e7eb',
  },

  button: {
    flex: '0 1 auto',

    minWidth: '155px',
    minHeight: '42px',

    padding: '9px 18px',

    border: '1px solid #000000',
    borderRadius: '9px',

    background:
      'linear-gradient(135deg, #27272a, #000000)',

    color: '#ffffff',

    fontSize: '14px',
    fontWeight: '800',

    cursor: 'pointer',

    boxShadow:
      '0 5px 12px rgba(0, 0, 0, 0.2)',

    transition: 'all 0.2s ease',
  },

  buttonRed: {
    border: '1px solid #dc2626',

    background:
      'linear-gradient(135deg, #ef4444, #dc2626)',

    color: '#ffffff',

    boxShadow:
      '0 5px 12px rgba(220, 38, 38, 0.2)',
  },

  buttonSecundario: {
    border: '1px solid #d1d5db',
    background: '#ffffff',
    color: '#374151',
    boxShadow: 'none',
  },

  buttonDisabled: {
    border: '1px solid #d1d5db',
    background: '#e5e7eb',
    color: '#9ca3af',

    boxShadow: 'none',

    cursor: 'not-allowed',
    opacity: 0.65,
  },

  estiloBotaoFechar: {
    minWidth: '110px',
    minHeight: '42px',
    padding: '9px 18px',
    border: '1px solid #dc2626',
    borderRadius: '9px',
    background: 'linear-gradient(135deg, #ef4444, #b91c1c)',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: '800',
    cursor: 'pointer',
    boxShadow: '0 5px 12px rgba(220, 38, 38, 0.20)',
  }
};

export default IdentificarConsumidor;
